import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST /api/anonymous/auth</h1>
        </div>
        <p>
          Creates an anonymous account on Avaya Spaces. Returns a unique JSON
          Web Token (JWT) that must be used to authorize anonymous access.
          Includes options for specifying the anonymous user's display name,
          username, and picture URL. Note that the JWT returned expires after 24
          hours.
        </p>
        <p>
          See <Link to="/tutorials/authorizingRequests">here</Link> for using
          JWT to access Avaya Spaces APIs.
        </p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>displayname</td>
                <td>The user's full name</td>
                <td>String</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>username</td>
                <td>The user's email address, or another unique username</td>
                <td>String</td>
                <td>No</td>
                <td />
              </tr>
              <tr>
                <td>picturefile</td>
                <td>The URL of the the user's profile photo.</td>
                <td>String</td>
                <td>No</td>
                <td>
                  '{"{"}FQDN{"}"}/norevimages/noimage.jpg'
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authorization</h2>
        <p>None required.</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/anonymous/auth
        </pre>
        <h4>Headers</h4>
        <p>None.</p>
        <h4>Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"displayname": "anonymous ab",{"\n"}
          {"  "}"username":"aUniqueNameABC"{"\n"}
          {"}"}
          {"\n"}
          {"    "}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"token":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhbm9ueW1vdXNfaWQiOiI1OGZlMDJmZDBjNmM0NDA1ZDQwN2EyYWYiLCJwcm9kdWN0X3R5cGUiOiJvbmVzbmEiLCJpc3MiOlsiemFuZyIsImlvIl0sImlhdCI6MTQ5MzA0MTkxNywiZXhwIjoxNDkzMTI4MzE3fQ.zF82MaqDQbD4hjcvf5vlb7RfVugLkb3vZt628UZZZKE"
          {"\n"}
          {"}"}
          {"\n"}
          {"    "}
        </pre>
      </div>
    </div>
  </Layout>
)
